export default "__VITE_ASSET__787439eb__"